import Route from '@ember/routing/route';
import { service } from '@ember/service';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';
import Store from '@ember-data/store';

export default class AdminAddressChangesIndexRoute extends Route {
  @service declare navbarSettings: NavbarSettingsService;
  @service declare store: Store;

  beforeModel() {
    this.navbarSettings.title = 'Address Changes';
  }

  model() {
    return this.store.query('admin/contact-address-change', {
      filter: { limit: 500 },
    });
  }
}
